import { z } from "zod"

import { entityIdSchema, legalEntityIdSchema } from "./identifiers.js"

const dateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/)
const reasonSchema = z.string().trim().min(12).max(500)

const accountingPeriodWindowV1Schema = z.object({
  periodId: entityIdSchema,
  legalEntityId: legalEntityIdSchema,
  startDate: dateSchema,
  endDate: dateSchema,
}).strict()

const increasingWindow = (value: {
  startDate: string
  endDate: string
}) => value.endDate >= value.startDate

export const accountingPeriodPreviewV1Schema =
  accountingPeriodWindowV1Schema.refine(increasingWindow, {
  message: "Invalid period window.",
})

export const accountingPeriodCloseV1Schema =
  accountingPeriodWindowV1Schema.extend({
    previewFingerprint: z.string().regex(/^[a-f0-9]{64}$/),
    reason: reasonSchema,
  }).strict().refine(increasingWindow, {
    message: "Invalid period window.",
  })

export const accountingPeriodResultV1Schema = z.object({
  entityType: z.literal("accounting_period"),
  entityId: entityIdSchema,
  state: z.enum(["preview", "closed"]),
  version: z.number().int().nonnegative(),
  legalEntityId: legalEntityIdSchema,
  startDate: dateSchema,
  endDate: dateSchema,
  previewFingerprint: z.string().regex(/^[a-f0-9]{64}$/),
  blockers: z.array(z.object({
    code: z.enum([
      "draft_accounting_document",
      "tax_review",
      "reconciliation_exception",
      "unbilled_work",
    ]),
    count: z.number().int().positive(),
  }).strict()).max(4),
  canClose: z.boolean(),
  erpnextAccountingPeriod: z.string().trim().min(1).max(140).nullable(),
}).strict()

export type AccountingPeriodPreviewV1 = z.infer<
  typeof accountingPeriodPreviewV1Schema
>
export type AccountingPeriodCloseV1 = z.infer<
  typeof accountingPeriodCloseV1Schema
>
export type AccountingPeriodResultV1 = z.infer<
  typeof accountingPeriodResultV1Schema
>
